import React from 'react';

import { PromoIcon } from '../../common/PromoIcon/PromoIcon';
import {
    CrossProductBanner,
    CrossProductDescription,
    CrossProductTitle,
    Illustration,
    Inner,
    LearnMore,
    Link,
    Logos,
    SwiperContainer,
    SwiperSlide,
    SwiperWrapper,
    TextContent,
} from '../styles';

const CrossProductsLanding = (props) => {
    const { pathFirstSlider, pathSecondSlider, imgFirstSlider, imgSecondSlider, logosSecondSlider, learnMore } = props;
    return (
        <div className="section-cross-products">
            <div className="box-1280">
                <div className="inner-content">
                    <SwiperContainer>
                        <SwiperWrapper>
                            <SwiperSlide>
                                <CrossProductBanner href={pathFirstSlider}>
                                    <Inner>
                                        <TextContent>
                                            <CrossProductTitle>{props.sliderCrossProdTitle1}</CrossProductTitle>
                                            <CrossProductDescription>{props.sliderCrossProdText1}</CrossProductDescription>
                                            <Link>
                                                <LearnMore>{learnMore}</LearnMore>
                                                <PromoIcon name="chevron-right" size="24px" color="primary" />
                                            </Link>
                                        </TextContent>
                                        <Illustration>{imgFirstSlider}</Illustration>
                                    </Inner>
                                </CrossProductBanner>
                            </SwiperSlide>
                            <SwiperSlide>
                                <CrossProductBanner href={pathSecondSlider}>
                                    <Inner>
                                        <Logos>
                                            <figure>{logosSecondSlider}</figure>
                                        </Logos>
                                        <TextContent>
                                            <CrossProductTitle>{props.sliderCrossProdTitle2}</CrossProductTitle>
                                            <CrossProductDescription>{props.sliderCrossProdText2}</CrossProductDescription>
                                            <Link>
                                                <LearnMore>{learnMore}</LearnMore>
                                                <PromoIcon name="chevron-right" size="24px" color="primary" />
                                            </Link>
                                        </TextContent>
                                        <Illustration>{imgSecondSlider}</Illustration>
                                    </Inner>
                                </CrossProductBanner>
                            </SwiperSlide>
                        </SwiperWrapper>
                    </SwiperContainer>
                </div>
            </div>
        </div>
    );
};

export default CrossProductsLanding;
